enum ErrorScreenTypeEnum {
    LoadingError = 'Loading',
    GenericError = 'Generic',
    ProviderUnavailableError = 'Provider',
    DataSharingCancelledError = 'DataSharing',
    ReAuthenticateCancelledError = 'ReAuthenticate',
    PaymentAccountConfirmationCancelledError = 'PaymentAccountConfirmationCancelled',
    PaymentAccountConfirmationError = 'PaymentAccountConfirmation',
    ReconfirmationError = 'Reconfirmation',
    RevocationError = 'Revocation'
}

export default ErrorScreenTypeEnum;
